import styled from "styled-components";
const NotificationsPageDisplay = styled.div`
	// my css here
`;	export default NotificationsPageDisplay;
